import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "desktop_nav" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Anika Wagner")
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "navigation" }
const _hoisted_5 = { class: "nav_list" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Galerie")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Über mich")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Kontakt")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Impressum")
const _hoisted_10 = { class: "mobile_navigation" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("a", {
  href: "./index.html",
  class: "name_header",
  title: "Link zur Startseite"
}, "Anika Wagner", -1)
const _hoisted_12 = {
  href: "./index.html",
  class: "logo_header",
  title: "Startseite"
}
const _hoisted_13 = ["src"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  for: "hamburg",
  class: "hamburg"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "line" }),
  /*#__PURE__*/_createElementVNode("span", { class: "line" }),
  /*#__PURE__*/_createElementVNode("span", { class: "line" })
], -1)
const _hoisted_15 = {
  key: 0,
  id: "mobile_nav_list"
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Galerie")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Über mich")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Kontakt")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Impressum")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "name_header",
        title: "Link zur Startseite"
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/",
        class: "logo_header",
        title: "Startseite"
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: require('@/assets/' + _ctx.awImgSrc),
            alt: "AW in gemalten Farben"
          }, null, 8, _hoisted_3)
        ]),
        _: 1
      }),
      _createElementVNode("nav", _hoisted_4, [
        _createElementVNode("ul", _hoisted_5, [
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/galerie",
              class: _normalizeClass({'navLink':true, 'active':(_ctx.activeItem === '0')})
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/ueberMich",
              class: _normalizeClass({'navLink':true, 'active':(_ctx.activeItem === '1')})
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/kontakt",
              class: _normalizeClass({'navLink':true, 'active':(_ctx.activeItem === '2')})
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/impressum",
              class: _normalizeClass({'navLink':true, 'active':(_ctx.activeItem === '3')})
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }, 8, ["class"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _createElementVNode("a", _hoisted_12, [
        _createElementVNode("img", {
          src: require('@/assets/' + _ctx.awImgSrc),
          alt: "AW in gemalten Farben"
        }, null, 8, _hoisted_13)
      ]),
      _createElementVNode("nav", null, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          id: "hamburg",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showMobileNav) = $event)),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleShowMobileNav()))
        }, null, 512), [
          [_vModelCheckbox, _ctx.showMobileNav]
        ]),
        _hoisted_14
      ])
    ]),
    (_ctx.showMobileNav)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_15, [
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/galerie",
              class: _normalizeClass({'navLink':true, 'active':(_ctx.activeItem === '0')}),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleShowMobileNav()))
            }, {
              default: _withCtx(() => [
                _hoisted_16
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/ueberMich",
              class: _normalizeClass({'navLink':true, 'active':(_ctx.activeItem === '1')}),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleShowMobileNav()))
            }, {
              default: _withCtx(() => [
                _hoisted_17
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/kontakt",
              class: _normalizeClass({'navLink':true, 'active':(_ctx.activeItem === '2')}),
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleShowMobileNav()))
            }, {
              default: _withCtx(() => [
                _hoisted_18
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/impressum",
              class: _normalizeClass({'navLink':true, 'active':(_ctx.activeItem === '3')}),
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toggleShowMobileNav()))
            }, {
              default: _withCtx(() => [
                _hoisted_19
              ]),
              _: 1
            }, 8, ["class"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}